"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultKeyboardBindings = void 0;
exports.defaultKeyboardBindings = {
    expandSiblings: ['control+*'],
    moveFocusToFirstItem: ['home'],
    moveFocusToLastItem: ['end'],
    primaryAction: ['enter'],
    renameItem: ['f2'],
    abortRenameItem: ['escape'],
    toggleSelectItem: ['control+ '],
    abortSearch: ['escape', 'enter'],
    startSearch: [],
    selectAll: ['control+a'],
    startProgrammaticDnd: ['control+shift+d'],
    completeProgrammaticDnd: ['enter'],
    abortProgrammaticDnd: ['escape'],
};
